var L = Object.defineProperty;
var i = Object.getOwnPropertySymbols;
var I = Object.prototype.hasOwnProperty, P = Object.prototype.propertyIsEnumerable;
var y = (e, r, n) => r in e ? L(e, r, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[r] = n, u = (e, r) => {
  for (var n in r || (r = {}))
    I.call(r, n) && y(e, n, r[n]);
  if (i)
    for (var n of i(r))
      P.call(r, n) && y(e, n, r[n]);
  return e;
};
var T = (e, r) => {
  var n = {};
  for (var t in e)
    I.call(e, t) && r.indexOf(t) < 0 && (n[t] = e[t]);
  if (e != null && i)
    for (var t of i(e))
      r.indexOf(t) < 0 && P.call(e, t) && (n[t] = e[t]);
  return n;
};
import { jsx as s, jsxs as z } from "react/jsx-runtime";
import o from "../../../node_modules/prop-types/index.es.js";
import E, { lazy as R, useId as S, Suspense as A } from "react";
import * as F from "./style.es.js";
import { Base as V, PhoneInputWrapper as _, Label as q } from "./style.es.js";
import { Helper as w } from "../../DataDisplay/Helper/Helper.es.js";
import { INPUT_VARIANT as b } from "../../../constants/inputVariant.es.js";
import { COMPONENT_SIZE as O } from "../../../constants/sizes.es.js";
const B = R(() => import("react-phone-input-2")), c = E.forwardRef((M, v) => {
  var d = M, {
    id: e,
    name: r,
    value: n,
    onFocus: t,
    onChange: g,
    country: $ = "us",
    label: p = "",
    helperText: j,
    disabled: a,
    variant: x = b.standard,
    size: l = O.md,
    error: m = !1,
    success: f = !1,
    inputProps: C = {}
  } = d, N = T(d, [
    "id",
    "name",
    "value",
    "onFocus",
    "onChange",
    "country",
    "label",
    "helperText",
    "disabled",
    "variant",
    "size",
    "error",
    "success",
    "inputProps"
  ]);
  const h = S();
  return /* @__PURE__ */ s(V, { $size: l, $error: m, $success: f, $variant: x, $hasLabel: !!p, $disabled: a, $hasValue: !!n, children: /* @__PURE__ */ z(_, { children: [
    /* @__PURE__ */ s(A, { children: /* @__PURE__ */ s(B, u({ inputClass: "form-input phone-input", containerClass: "phone-input-container", inputProps: u({
      id: e || h,
      name: r,
      disabled: a
    }, C), countryCodeEditable: !1, specialLabel: p, onFocus: t, onChange: g, country: $, value: n, disabled: a, ref: v }, N)) }),
    p && /* @__PURE__ */ s(q, { htmlFor: e || h, children: p }),
    /* @__PURE__ */ s(w, { text: j, error: m, success: f, size: l })
  ] }) });
}), H = {
  id: o.string,
  name: o.string,
  value: o.string,
  onFocus: o.func,
  onChange: o.func,
  country: o.string,
  label: o.oneOfType([o.node, o.string]),
  helperText: o.oneOfType([o.node, o.string]),
  disabled: o.bool,
  variant: o.oneOf(Object.values(b)),
  size: o.oneOf(Object.values(O)),
  error: o.bool,
  success: o.bool,
  inputProps: o.object
};
c.S = F;
c.displayName = "PhoneInput";
c.propTypes = H;
export {
  c as PhoneInput,
  H as phoneInputPropTypes
};
//# sourceMappingURL=PhoneInput.es.js.map
